<template>
  <div>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="white"
      flat
    >
      <v-app-bar-nav-icon @click="toggleNav((drawer = !drawer))" />
      <v-toolbar-title class="mt-1 pl-4">
        <a href="/">
          <img class="d-md-none" :src="logoSm" width="35px" alt="CPES" />
          <img
            class="d-none d-md-block"
            :src="logoSm"
            width="50px"
            alt="CPES"
          />
        </a>
      </v-toolbar-title>

      <v-spacer />
      <v-btn icon>
        <v-btn
          icon
          @click="
            toggleNotificationDrawer((notificationDrawer = !notificationDrawer))
          "
        >
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </v-btn>
      <!-- <v-btn icon> <v-icon>mdi-bell</v-icon> </v-btn> -->
      <v-btn icon>
        <v-avatar item>
          <ProfileMenu @profileData="updateProfile($event)" />
        </v-avatar>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import ProfileMenu from "./ProfileMenu";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  components: { ProfileMenu },
  data: () => ({
    name: null,
    logo: require("@/assets/logo.png"),
    logoSm: require("@/assets/logo_sm.png"),
  }),

  computed: {
    drawer: {
      get() {
        return this.$store.state.auth.drawer;
      },
      set(value) {
        this.$store.commit("auth/setDrawer", value);
      },
    },
    notificationDrawer: {
      get() {
        return this.$store.state.auth.notificationDrawer;
      },
      set(value) {
        this.$store.commit("auth/setNotificationDrawer", value);
      },
    },

    ...mapGetters({}),
  },

  methods: {
    toggleNav: function(value) {
      this.$store.dispatch("auth/changeDrawer", value);
    },
    toggleNotificationDrawer: function(value) {
      this.$store.dispatch("auth/changeNotificationDrawer", value);
    },

    updateProfile(value) {
      this.name = value.display_name;
    },
  },
};
</script>
<style>
.v-toolbar__content {
  align-items: center;
  display: flex;
  position: relative;
  z-index: 0;
  border-bottom: solid 1px #e2e8f0;
}
</style>
